export default __webpack_public_path__ + "static/media/botoes_genericos_03.70cb7c6d.mp3";